import React from 'react';

import { Typography } from 'antd';

import type { TooltipProps } from 'recharts';
import type { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent';
import { Mask } from 'v2/components/Shared/ValuesVisibility';

import { SERIES_TEXT_COLOR_CLASS, type LineChartSeriesKey } from '../../seriesColors';

type CustomTooltipProps = TooltipProps<ValueType, NameType>;

const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  return (
    <div className='border border-(--uizz-antd-color-border) bg-(--uizz-antd-color-bg-container) px-3 py-2'>
      <Typography.Text strong>{label}</Typography.Text>

      {payload
        .filter(entry => entry.type !== 'none' && entry.name !== entry.dataKey)
        .map(entry => (
          <div key={String(entry.name ?? entry.dataKey)}>
            <Typography.Text className={SERIES_TEXT_COLOR_CLASS[entry.dataKey as LineChartSeriesKey]}>
              {`${entry.name}: `}
              <Mask>{entry.value}</Mask>
            </Typography.Text>
          </div>
        ))}
    </div>
  );
};

export default CustomTooltip;
